import { LoginResponse, QrPollResponse, UserDetails } from '@repo/types';
import { makeRequest } from './base';

export const loginPortal = (payload: string): Promise<LoginResponse> => {
  return makeRequest('post', '/api/auth/login', {
    detail: payload,
  });
};

export const loginAdmin = (payload: string): Promise<LoginResponse> => {
  return makeRequest('post', '/api/admin/login', {
    detail: payload,
  });
};

export const getUserDetails = (): Promise<UserDetails> => {
  return makeRequest('get', '/api/auth/user-detail');
};

export const pollQrLogin = (qrToken: string): Promise<QrPollResponse> => {
  return makeRequest('post', '/api/auth/login/qr/poll', {
    qr_token: qrToken,
  });
};
